import { Link } from "react-router-dom";
import { homeCollections } from "@/utils/catalog";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CollectionSpotlight() {
  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="评分推荐"
        title="精选专题合集"
        description="由编辑整理的评分推荐合辑，按主题一次性看够同类优质作品。"
      />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {homeCollections.map((collection) => (
          <Link
            key={collection.id}
            to="/movies"
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-44 w-full overflow-hidden bg-background-200">
              <img
                src={collection.image}
                alt={collection.title}
                title={`${collection.title} 影视专题`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute right-3 top-3 rounded-md bg-background-950/70 px-2 py-1 text-xs font-medium text-background-50">
                共 {collection.count} 部
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {collection.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">
                {collection.lead}
              </p>
              <span className="mt-4 flex items-center gap-1 text-sm font-medium text-accent-600">
                查看专题
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}